import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup } from "react-bootstrap";
import { LoaderButton, ContinueLabel } from "ctia-ui";
import InputFile from "components/form/InputFile";
import { submitWizardStep } from "actions/wizard";
import { handleFileChange } from "actions/request";

const rbDocs = [
  {
    id: "rbdoc-manual",
    title: "Product Description"
  },
  {
    id: "rbdoc-equality",
    title: "Product Equality Letter"
  },
  {
    id: "rbdoc-auth-use",
    title: "Authorization of Use Letter"
  }
];

class RebrandDocs extends Component {
  validate() {
    // const { request } = this.props;
    // return _.every(rbDocs, doc => request[doc.id]);
    return true;
  }

  onContinue = () => this.props.submitWizardStep(this.props.wizard);

  render() {
    const { handleFileChange, request } = this.props;
    return (
      <div>
        {rbDocs.map(foo => {
          const fileRef = request[foo.id] ? request[foo.id].file : null;
          return (
            <div key={foo.id}>
              <h3>{foo.title}</h3>
              <FormGroup>
                <InputFile
                  id={foo.id}
                  name={foo.id}
                  onChange={handleFileChange.bind(this, request[foo.id])}
                  disabled={false}
                  file={fileRef}
                />
              </FormGroup>
            </div>
          );
        })}
        <hr />
        <div className="text-right">
          <LoaderButton
            bsStyle="info"
            text={<ContinueLabel />}
            disabled={!this.validate()}
            isLoading={request.isLoading}
            onClick={this.onContinue}
            // show={isNewRequest}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ request, wizard }) {
  return { request, wizard };
}

export default connect(mapStateToProps, {
  submitWizardStep,
  handleFileChange
})(RebrandDocs);



// WEBPACK FOOTER //
// ./src/containers/request/Rebrand/RebrandDocs.js